import { render, staticRenderFns } from "./AsideMenuList.vue?vue&type=template&id=70e656da&scoped=true"
import script from "./AsideMenuList.vue?vue&type=script&lang=js"
export * from "./AsideMenuList.vue?vue&type=script&lang=js"
import style0 from "./AsideMenuList.vue?vue&type=style&index=0&id=70e656da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e656da",
  null
  
)

export default component.exports